import { render } from "./sync-health-list-section.vue?vue&type=template&id=3efde05d&scoped=true"
import script from "./sync-health-list-section.vue?vue&type=script&lang=js"
export * from "./sync-health-list-section.vue?vue&type=script&lang=js"

import "./sync-health-list-section.vue?vue&type=style&index=0&id=3efde05d&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3efde05d"]])

export default __exports__